import { attachPropertiesToComponent } from '../utils/inner-use/attach-properties-to-component';
import { ImageViewerInner } from './image-viewer';
import { dialogImageViewer } from './methods';

export const ImageViewer = attachPropertiesToComponent(ImageViewerInner, {
  show: dialogImageViewer,
});
